let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("386zu")).then(() => parcelRequire('2Eqp0'));